import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useLanguages() {
  const [loading, setLoading] = useState(true);
  const [languages, setLanguages] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.languages.index)
      .then((response) => {
        setLanguages(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, languages };
}
